import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { ScrollView, View } from 'native-base';
import React from 'react';

import { Complete } from './components/Complete';
import { Customer } from './components/Customer';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Tabs } from './components/Tabs';

export const Consortium = () => {
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View minW="container">
        <VStack
          py={Spacing['inset.lg']}
          space={Spacing['inline.xxs']}
          px={{ base: Spacing['stack.xxxs'], sm: Spacing['inline.xxs'], lg: 0 }}>
          <Header title="Consórcio" />
          <Customer />
          <Tabs />
          <Complete />
          <Footer />
        </VStack>
      </View>
    </ScrollView>
  );
};
